import { c as _c } from "react/compiler-runtime";
import { SearchInput, SegmentedControl } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import type { ToolFilter } from '../hooks/use-builder-navigation';

// A shorter list fits on screen whole, so filtering it only stacks a toolbar over a few rows.
const MIN_ROWS_TO_FILTER = 6;

// The filter and search live in the URL, so one set on a longer list can outlast its toolbar. Once
// the toolbar is hidden, neither may keep hiding rows.
const activeToolFilters = (rowCount: number, filter: ToolFilter, query: string) => {
  const canFilter = rowCount >= MIN_ROWS_TO_FILTER;
  const activeFilter: ToolFilter = canFilter ? filter : 'all';
  return {
    canFilter,
    filter: activeFilter,
    needle: canFilter ? query.trim().toLowerCase() : ''
  };
};
type ToolFiltersProps = {
  filter: ToolFilter;
  query: string;
  enabledCount: number;
  onFilterChange: (filter: ToolFilter) => void;
  onQueryChange: (query: string) => void;
  label: string;
  searchLabel: string;
};
const ToolFilters = t0 => {
  const $ = _c(33);
  const {
    filter,
    query,
    enabledCount,
    onFilterChange,
    onQueryChange,
    label,
    searchLabel
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.tools.filters"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = {
      value: "all",
      label: t2
    };
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== enabledCount || $[6] !== t) {
    t4 = t(_temp2, {
      count: enabledCount
    });
    $[5] = enabledCount;
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = {
      value: "enabled",
      label: t4
    };
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t(_temp3);
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = {
      value: "notEnabled",
      label: t6
    };
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t3 || $[15] !== t5 || $[16] !== t7) {
    t8 = [t3, t5, t7];
    $[14] = t3;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== filter || $[19] !== label || $[20] !== onFilterChange || $[21] !== t8) {
    t9 = <SegmentedControl aria-label={label} size="compact" value={filter} onChange={onFilterChange} options={t8} />;
    $[18] = filter;
    $[19] = label;
    $[20] = onFilterChange;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== onQueryChange) {
    t10 = () => onQueryChange("");
    $[23] = onQueryChange;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== onQueryChange || $[26] !== query || $[27] !== searchLabel || $[28] !== t10) {
    t11 = <div className="w-full @lg:w-56"><SearchInput size="compact" aria-label={searchLabel} placeholder={searchLabel} value={query} onChangeText={onQueryChange} onReset={t10} /></div>;
    $[25] = onQueryChange;
    $[26] = query;
    $[27] = searchLabel;
    $[28] = t10;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t11 || $[31] !== t9) {
    t12 = <div className="flex flex-col gap-3 @lg:flex-row @lg:items-center @lg:justify-between">{t9}{t11}</div>;
    $[30] = t11;
    $[31] = t9;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  return t12;
};
export { activeToolFilters };
export default ToolFilters;
function _temp($) {
  return $.all;
}
function _temp2($_0) {
  return $_0.enabledCount;
}
function _temp3($_1) {
  return $_1.notEnabled;
}